var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "breadcrumbs sml-hide" },
    [
      _vm._l(_vm.items, function (item) {
        return [
          _c(
            "a",
            {
              staticClass: "breadcrumbs__item breadcrumbs__item_link",
              attrs: { href: item.url, title: item.text },
            },
            [_vm._v(_vm._s(item.text))]
          ),
        ]
      }),
      _vm._v(" "),
      _c("span", { staticClass: "breadcrumbs__item" }, [
        _vm._v(_vm._s(_vm.name)),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }